import Footer from 'comps/Footer';
import Header from 'comps/Header';
import Layout from 'comps/Layout';
import { shopNameFormat } from 'comps/ShopModuleNav';
import ShopPagePCContent from 'comps/ShopPagePCContent';

export default function PagesShopPro(props) {
  const showAreaCascader = !props?.shopData?.uiConfig?.find((i) => i.type === 'productList');
  return (
    <Layout
      header={<Header showAreaCascader={showAreaCascader} showNav={false} />}
      footer={<Footer />}
      title={`店铺${shopNameFormat(props?.shopData)}`}
      keywords=""
      description=""
      supplierSysNo={props?.shopData?.shopViewEntity?.supplierSysNo}
    >
      <ShopPagePCContent {...props} />
    </Layout>
  );
}
